import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath, newParameterToPath } from 'utils';
import { AccountStatus } from 'interfaces';

export type User = {
  user_id?: number; // 유저 idx
  user_account?: string; // 회원 ID
  password?: string; // 회원 비밀번호
  user_name?: string; // 회원명
  user_phone?: string; // 회원 연락처
  user_email?: string; // 회원 이메일
  user_gender?: string; // 성별
  user_address?: string; // 주소
  user_address_detail?: string; // 상세 주소
  memo?: string; // 메모
  user_setting?: { [key: string]: Record<string, any> }; // 회원 개인설정
  access_time?: number; // 로그인 이력
  withdrawal_time?: number; // 탈퇴일
  account_status?: (typeof AccountStatus)[keyof typeof AccountStatus]; // 계정 상태
  pw_change_time?: number; // 비밀번호 변경일자
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] User
   * --
   */
  getUsers: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_USER, params);
      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] User
   * --
   */
  getUser: async (idx: number, params?: { [key: string]: string | number }) => {
    try {
      const url = parameterToPath(APIConstant.GET_USER, { user_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },
  /**
   * [GET] User
   * --
   */
  getGuestUser: async (
    idx: number,
    authNumber: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = newParameterToPath(APIConstant.GET_GUEST_USER, {
        user_id: idx,
        authNumber,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] User
   * --
   */
  createUser: async (body: User) => {
    try {
      const res = await $http.post(APIConstant.CREATE_USER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] User
   * --
   */
  updateUser: async (body: User) => {
    try {
      const { user_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_USER, {
        user_id: user_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] User
   * --
   */
  deleteUser: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_USER, {
        user_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] User
   * --
   */
  updateGuestUser: async (body: User) => {
    try {
      const res = await $http.put(APIConstant.UPDATE_USER_GUEST, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  bulkUpsertUser: async (body: User[]) => {
    try {
      const res = await $http.bulk(APIConstant.BULK_UPSERT_USER, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  bulkUpdateUserGrade: async (body: User[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPDATE_USER_GRADE,
        body,
        'PUT'
      );

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
